<div class="ks-dialog">
  <h2 mat-dialog-title class="ks-dialog__title">{{ title }}</h2>

  <mat-dialog-content class="ks-dialog__content">
    <p>{{ message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="ks-dialog__actions">
    <button mat-stroked-button type="button" class="ks-dialog__cancel" (click)="cancel()">
      Cancel
    </button>
    <button mat-flat-button type="button" class="ks-dialog__confirm" (click)="confirm()">
      {{ confirmLabel }}
    </button>
  </mat-dialog-actions>
</div>
